import { render } from "./IdentityPage.vue?vue&type=template&id=33001fd2&scoped=true"
import script from "./IdentityPage.vue?vue&type=script&lang=js"
export * from "./IdentityPage.vue?vue&type=script&lang=js"

import "./IdentityPage.vue?vue&type=style&index=0&id=33001fd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33001fd2"]])

export default __exports__